const STRINGS = {
	QUICKVIEW_ID: 'quickview-ajax'
}

const SELECTORS_QUICKVIEW = {
	QUICKVIEW_OPEN: '.js-quickview-ajax-trigger',
	QUICKVIEW_CONTENT: '.js-quickview-content'
}

const quickviewContent = document.querySelector(SELECTORS_QUICKVIEW.QUICKVIEW_CONTENT);

const quickviewInit = () => {


    document.addEventListener('click', function(e) {
        const el = e.target ? e.target.closest('.js-quickview-ajax-trigger') : null;

        if (el) {
            openModal(e)
        }
    });

	// drawerOpen is triggered in theme.js.liquid
	// $('body').on('drawerOpen', closeModal);
}

const openModal = event => {
	MicroModal.show('quickview-ajax', {
		onShow: (modal) => {
			axios.get(`/products/${event.target.closest('.js-quickview-ajax-trigger').dataset.handle}?view=quick-view`)
				.then(response => {
					populateModal(response.data);
				})
				.catch(error => {
					console.log(error);
				});
		},
		onClose: (modal) => {
			quickviewContent.innerHTML = '';
		},
		awaitOpenAnimation: true,
		awaitCloseAnimation: true,
		disableScroll: true
	});
}

const closeModal = () => {
	let quickviewModal = document.getElementById(STRINGS.QUICKVIEW_ID);

	if (quickviewModal.classList.contains('is-open')) {
		MicroModal.close(STRINGS.QUICKVIEW_ID);
	}
}

const populateModal = productHTML => {
	quickviewContent.innerHTML = productHTML;

	// hooking into initialization code for product functionality found in theme.js.liquid below

	// Refresh reviews app
	if (window.SPR) {
		SPR.initDomEls();
		SPR.loadBadges();
	}

	// re-register product template in theme.js
  	theme.sections.register('product', theme.Product);

	// init Shopify dynamic buttons
	if (Shopify.PaymentButton) {
		Shopify.PaymentButton.init();
	}

	// reinit the product images. see https://github.com/michalsnik/aos
	AOS.refreshHard();
}

window.addEventListener('DOMContentLoaded', event => {
    quickviewInit();
});

